export const COMPONENT_MAIN = 'WorkTimeCfgMain';
export const COMPONENT_LIST = 'WorkTimeCfgList';
export const COMPONENT_DETAIL = 'WorkTimeCfgDetail';


export const TAB_LIST = 'list';
export const OPERATION_LIST_DEFAULT = 'list.default';

export const TAB_DETAIL = 'detail';
export const OPERATION_DETAIL_SHOW = 'detail.show';
export const OPERATION_DETAIL_ADD = 'detail.add';
export const OPERATION_DETAIL_EDIT = 'detail.edit';

export const FN_SET_OPERATION = 'setOperation';
export const FN_SET_TAB = 'setTab';

export const FN_LIST_QUERY = 'query';

export const FN_TO_DETAIL_SHOW = 'toDetailShow';

export const PERMISSION_ADD = null;
export const PERMISSION_EDIT = null;
export const PERMISSION_DELETE = null;

export const ENUM_WORK_TIME_STATUS_DRAFT = 'DRAFT';
export const ENUM_WORK_TIME_STATUS_ENABLED = 'ENABLED';
export const ENUM_WORK_TIME_STATUS_DISABLED = 'DISABLED';

export const ENUM_WORK_TIME_NAME_NORMAL = 'NORMAL';
export const ENUM_WORK_TIME_NAME_DAY = 'DAY';
export const ENUM_WORK_TIME_NAME_NIGHT = 'NIGHT';

export const ENUM_WORK_TIME_TYPE_NORMAL = 'NORMAL';
export const ENUM_WORK_TIME_TYPE_TURN = 'TURN';
